var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightOpenNoLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51 4.998l-3.2 3.21a1.05 1.05 0 000 1.482c.409.41 1.07.41 1.478 0l3.91-3.922A1.04 1.04 0 006 4.998a1.04 1.04 0 00-.301-.769L1.788.307a1.042 1.042 0 00-1.477 0 1.05 1.05 0 000 1.482L3.51 5z",
    fill: "#D7DDE4"
  })));
}
export default SvgArrowRightOpenNoLine;